import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Imgix from 'react-imgix';

class HeroImage extends React.Component {
  render() {
    const { storefrontSetting, shouldNotDisplayFigure, picture, alt } = this.props;
    const { homeVisible, homeCarouselItems } = storefrontSetting;

    if (picture) {
      return (
        <figure>
          <Imgix
            src={picture.imgixUrl}
            alt={alt || 'hero'}
            sizes='50vw'
          />
        </figure>
      );
    }

    if (homeVisible && homeCarouselItems.length > 0) {
      return (
        <figure>
          {homeCarouselItems[0].picture && (
            <Imgix
              src={homeCarouselItems[0].picture.imgixUrl}
              alt='hero'
              sizes='50vw'
              width={1024}
              height={740}
            />
          )}
        </figure>
      );
    } else if (shouldNotDisplayFigure) return null;
    else {
      return <figure />;
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parsedStorefrontSettings } = state.locations;
  const storefrontSetting =
    parsedStorefrontSettings.storefrontHomeSetting || {};
  return { storefrontSetting };
};

export default withRouter(connect(mapStateToProps)(HeroImage));
